@let errors = control | formErrors:errorKeyPrefix;
@let errorKeys = Object.keys(errors);

<!--<pre>{{ errors | json }}</pre>-->

@for (key of errorKeys; track key) {
    <h3 class="error__key">
        <span class="material-symbols-rounded">warning</span>
        <span>{{ labelMapper?.[key] || (key | autoLabel) }}</span>
    </h3>
    <ul class="error__messages">
        @let messages = errors[key];
        @for (message of messages; track message) {
            <li class="error__message">{{ message }}</li>
        }
    </ul>
}
